import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as sessionReducer from '@shared/reducers/session.reducer';
import { Session } from '@shared/models/session';
import { loadSession } from '@shared/actions/load-session.actions';
import { LoadingState } from '@shared/types/loading-state';
import { endSession, expireSessionAndLogout } from '@shared/actions/end-session.actions';
import { Config } from '@shared/models/config';
import { toggleMenu } from '@shared/actions/toggle-menu.actions';
import { UserType } from '@shared/types/user-type';
import { Permission } from '@shared/types/permission';
import { Group } from '@shared/models/group';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(private store: Store) {}

  loadSession() {
    this.store.dispatch(loadSession());
  }

  endSession() {
    this.store.dispatch(endSession());
  }

  expireSessionAndLogout(sessionExpired: boolean) {
    this.store.dispatch(expireSessionAndLogout({ sessionExpired }));
  }

  toggleMenu() {
    this.store.dispatch(toggleMenu());
  }

  getSessionLoading(): Observable<LoadingState> {
    return this.store.select(sessionReducer.selectSessionLoadingState);
  }

  getSessionLoadingText(): Observable<string | undefined> {
    return this.store.select(sessionReducer.selectSessionLoadingText);
  }

  getSession(): Observable<Session | undefined> {
    return this.store.select(sessionReducer.selectSession);
  }

  getGroups(): Observable<Partial<Group['attributes']>[] | undefined> {
    return this.store.select(sessionReducer.selectGroups);
  }

  getTradingEntityGroup(): Observable<Partial<Group['attributes']> | undefined> {
    return this.store.select(sessionReducer.selectTradingEntityGroup);
  }

  getTradingEntityGroupId(): Observable<string | undefined> {
    return this.store.select(sessionReducer.selectTradingEntityGroupId);
  }

  getUserType(): Observable<UserType | undefined> {
    return this.store.select(sessionReducer.selectUserType);
  }

  getSessionPermissions(): Observable<Permission[] | undefined> {
    return this.store.select(sessionReducer.selectSessionPermissions);
  }

  getConfig(): Observable<Config | undefined> {
    return this.store.select(sessionReducer.selectConfig);
  }

  getMenuOpen() {
    return this.store.select(sessionReducer.selectMenuOpen);
  }

  getLimitedAccessDaysLeft(): Observable<number | undefined> {
    return this.store.select(sessionReducer.selectLimitedAccessDaysLeft);
  }

  getLimitedAccessAllowed(): Observable<boolean | undefined> {
    return this.store.select(sessionReducer.selectLimitedAccessAllowed);
  }

  getAccessRestrictedWithoutAgreement(): Observable<boolean | undefined> {
    return this.store.select(sessionReducer.selectAccessRestrictedWithoutAgreement);
  }
}
